import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import '../styles/SideBar.scss';

const Sidebar2 = ({width, show, onHide, children}: {width:any, show:boolean, onHide:any, children:any}) => {
    const [showing, setShowing] = useState(false);

    useEffect(() => {
        setShowing(show);
    }, [show]);
    
    const hide = () => {
        if(onHide) {
            onHide();
        }
        setShowing(false);
    }

    return (
        <div className={`sidebar right ${showing ? "" : "collapsed"}`} style={{width: width}}>      
            <div className="sidebar-content">
                <div 
                    className="sidebar-close right"
                    onClick={() => hide()}
                >
                    { showing ? <FontAwesomeIcon icon={faTimes} /> : '' }
                </div>
                { children }     
            </div>
        </div>
    );
}

export default Sidebar2;